import {
    CompanyAction,
    CompanyActionTypes,
    SearchCompany
} from "../interfaces/context/searchContextInterfaces";

const defaultState = {
    userInputValue: "",
    userSelectedCompany: null,
    companySuggestions: []
};

export const companyReducer = (state: SearchCompany, action: CompanyAction) => {
    switch (action.type) {
    case CompanyActionTypes.updateCompany: {
        const updatedState = {
            ...state,
            userInputValue: action.payload.userInputValue === null ? "" : action.payload.userInputValue,
            userSelectedCompany: action.payload.userSelectedCompany
        };
        return updatedState;
    }
    case CompanyActionTypes.updateCompanySuggestions: {
        const updatedState = {
            ...state,
            companySuggestions: action.payload.companySuggestions
        };
        return updatedState;
    }
    case CompanyActionTypes.resetCompany: {
        return defaultState;
    }
    default: {
        return state;
    }
    }
};
